<template>
<div class="accordion">
	<h4 v-on:click="toggleState">
		{{heading}}
		<slot name="heading"></slot>
		<i v-if="!stayOpen" class="fa" :class="{
			'fa-chevron-down': isOpen,
			'fa-chevron-right': !isOpen
		}"></i>
	</h4>
	<div v-if="isOpen" class="accordion-container">
		<slot></slot>
	</div>
</div>
</template>
<script type="text/javascript">
export default {
	name: "Accordion",
	props: [
		"heading",
		"startOpen",
		"stayOpen"
	],
	data() {
		return  {
			isOpen: false
		}
	},
	watch: {
		stayOpen() {
			if (this.stayOpen)
				this.isOpen = true
		}
	},
	methods: {
		toggleState() {
			if (!this.stayOpen) {
				this.isOpen = !this.isOpen

				this.$emit("stateToggled",this.isOpen)
			}
		}
	},
	created() {
		if (this.startOpen || this.stayOpen)
			this.isOpen = true
	}
}
</script>

<style type="text/css" scoped>
	h4 {
		text-decoration: none;
		display: flex;
		justify-content: space-between;
		cursor: pointer;
		align-items: center;
		background-color: var(--brand-primary-color-faded);
		padding: 8px;
		margin-bottom: 0px;
	}

	.accordion {
		margin-bottom: 10px;
	}

	.accordion-container {
		padding-top: 10px;
	}
</style>